// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.product-page-container {
  width: 100%;
  display: flex;
  height: 90px;
  align-items: center;
  position: relative;
}

.find-your-text {
  width: 50%;
  padding-left: 4.2rem;
}
.ant-collapse .ant-collapse-content > .ant-collapse-content-box {
  padding: 16px 4px 12px 16px;
}
.search-input {
  font-family: Roboto;
  width: 583px !important;
  height: 50px;
}

.search-input .ant-input-prefix {
  margin-right: 1rem;
}
.search-f-loc .ant-input-prefix {
  margin-right: 1rem;
}

.search-input.ant-input-filled {
  background-color: #fff !important;
}

.search-input.ant-input-filled:focus {
  border-color: #000 !important;
}
.search-input:hover {
  border-color: #000 !important;
  width: 583px;
  height: 50px;
}
.price-filter-input-field {
  font-size: 12px;
}

.single-calendar .ant-picker-dropdown .ant-picker-content th {
  height: 36px;
  color: #a8a5a6 !important;
  vertical-align: middle;
}

.collapse-container-product.ant-collapse-borderless {
  background-color: white;
}
.collapse-container-productType.ant-collapse-borderless {
  background-color: white;
}
.ant-collapse-borderless > .ant-collapse-item > .ant-collapse-content {
  background-color: transparent;
  border-top: 0;
}

.time-square-billboard-table ::-webkit-scrollbar-thumb {
  background: #ea8c9e !important;
  border-radius: 10px;
}

.collapse-container-product.ant-collapse > .ant-collapse-item {
  border-bottom: none;
}

.collapse-container-productType.ant-collapse > .ant-collapse-item {
  border-bottom: none;
}
.ant-switch-checked {
  background-color: #d2042d !important;
}
.filters-apply-btn {
  background-color: #d2042d !important;
  color: #fff !important;
}
.filters-apply-btn:hover {
  border-color: #d2042d !important  ;
  background-color: #d2042d !important;
}

.advertisement-txt {
  font-family: Roboto;
  color: #0a0f0d;
  font-size: 19px;
  font-weight: 600;
}

.ant-switch-checked .ant-switch-handle {
  border-color: #ffffff;
}

.toggle-filters {
  font-family: Roboto;
  color: #000;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
}
.filters-count-badge {
  color: #fff;
  color: #d2042d !important;
  margin-left: 10px;
}
.cancel-filter-modal {
  background-color: #5b5e5d;
  color: #fff;
  border: "none";
}
.cancel-filter-modal:hover {
  background-color: #5b5e5d !important;
  color: #fff !important;
  border: "none" !important;
}
.clear-filter-modal {
  background-color: #d2042d;
  color: #fff;
  border: "none" !important;
}
.clear-filter-modal:hover {
  background-color: #d2042d !important;
  color: #fff !important;
  border: "none";
}
.product-sh {
  height: 90px;
}

.sh-row {
  height: 90px;
  margin-left: 4.5rem;
}

.search-input-con {
  display: flex;
  align-items: end !important;
  justify-content: end !important;
  padding-right: 2rem !important;
}

.product-search-btn {
  height: 50px;
  width: 170px;
  background-color: #d2042d;
  margin-left: 10px;
}

.product-search-btn:hover {
  height: 50px;
  width: 170px;
  background-color: #d2042d !important;
  margin-left: 10px;
  border: none;
}

.search-txt {
  font-family: Roboto;
  color: #fff;
  font-size: 16px;
  font-weight: 600;
}

.filter-section {
  height: 100px;
  width: 100%;
  position: fixed;
}

.filter-section-card {
  background: #fff;
  min-height: 40vh;
  border-radius: 0;
  min-width: 20%;
}

.search-products-sh {
  width: 50%;
  display: flex;
  justify-content: end;
  padding-right: 2rem;
}

.filter-img {
  height: 24px;
  width: 24px;
}

.filter-txt {
  font-family: Roboto;
  font-size: 16px;
  font-weight: 700;
}

.filtersection-pad {
  padding: 10;
}

.filter-reset-btn {
  font-family: Roboto;
  float: right;
  color: #d2042d !important;
  font-weight: 500;
  font-size: 15px;
}
.filter-reset-btn:hover {
  float: right;
  color: #d2042d !important;
  font-weight: 500;
  font-size: 15px;
}
.create-campaign-bulk-btn {
  height: 35px;
  padding: 12px 20px;
  background: #d2042d !important;
  border-radius: 5px;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
  color: #fff !important;
  font-size: 14px !important;
  font-family: "Roboto";
  font-weight: 500;
}
.collapse-container-product {
  border: none;
  overflow-y: auto;
  height: 68vh;
}
.collapse-container-productType {
  border: none;
}

.collapse-pannel-container {
  font-family: Roboto;
  font-size: 14px;
  color: #0a0f0d;
  font-weight: 600;
}

.view-more-loc {
  display: "block";
  margin-top: "20px";
  margin-left: "27px";
  color: "#d2042d";
  font-family: "Roboto";
  font-size: "16px";
  font-weight: "500";
  cursor: "pointer";
}

.collapse-pannel-checkbox {
  display: flex;
  flex-direction: column;
  gap: 8px !important;
}

.products-list-container {
  background: #f7f7f7;
  padding: 20px;
  height: auto !important;
  min-height: 60vh !important;
  max-height: 66vh !important;
  overflow-y: scroll;
}

@media (max-width: 1370px) {
  .product-card-city {
    font-family: Roboto;
    font-size: 14px;
    color: #000;
  }
  .product-availability {
    font-size: 14px !important;
  }
}
@media (max-width: 1280px) {
  .products-list-container {
    background: #f7f7f7;
    padding: 20px;
    height: auto !important;
    min-height: 60vh !important;
    max-height: 63vh !important;
    overflow-y: scroll;
  }
  .cards-container {
    width: 100%;
  }
}
.ant-pagination .ant-pagination-item-active:hover {
  color: #d2042d;
  border-color: unset !important;
}
.map-view-section {
  height: 30vh;
  overflow-y: scroll;
  padding-left: 50px;
  padding-right: 10px;
}
.product-page-maps {
  height: 50vh;
  overflow-y: scroll;
}

.ant-pagination .ant-pagination-item-active:hover a {
  color: #d2042d;
  border-color: none;
}

.products-list-subcontainer {
  margin-bottom: 0px;
  width: 100%;
}

.location-icon-c {
  display: flex;
  justify-content: center;
}

.location-text {
  font-family: Roboto;
  font-size: 13px;
  color: #8e9190;
}

.address-text {
  font-family: Roboto;
  font-size: 14px;
  font-weight: 400;
}

.change-btn-text {
  color: #d2042d;
  text-decoration: underline;

  font-weight: 500;
  font-size: 16px;
}

.change-btn-text :hover {
  color: #d2042d;
  text-decoration: underline;
  font-weight: 500;
}
.collapse-pannel-checkbox-label {
  color: var(--Colors-Text-500, #0a0f0d);
  font-family: Roboto;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 1.5rem;
  display: flex;
  align-items: center;
}
.products-type-check-box-label-names {
  color: var(--Colors-Text-500, #0a0f0d);
  font-family: Roboto;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 1.5rem;
}
.toggle-filter-section {
  display: flex;
  justify-content: flex-end;
  padding-right: 42px;
}

.cards-container {
  width: 100%;
}

.product-page .ant-card .ant-card-body {
  padding-top: 15px !important;
  border-radius: 0 0 8px 8px;
}

.product-image-div {
  padding: 0px 0px 0px 0px;
}

.product-image {
  width: 140px;
  height: 140px;
  border-radius: 5px !important;
}

.vertical-line {
  margin: "0px auto";
  width: 1px;
  height: 2cm;
  background-color: #b3b5b4;
  margin-top: 5px;
}
.product-page .ant-divider-horizontal {
  display: flex;
  clear: both;
  width: 100%;
  min-width: 100%;
  margin: 0px 0;
}
.products-container {
  height: 65vh;
  overflow-y: auto;
}

.loc-truncate {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 400px;
  display: inline-block;
}
.product-availble-count {
  color: var(--Colors-Text-400, #3b3f3d);
  font-family: Roboto;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 1.5rem;
}
.product-id {
  font-size: 13px;
  color: #8e9190;
}

.available-txt {
  font-size: 13px;
}

.product-availability {
  font-size: 14px;
}

.product-size-img {
  width: 28px;
  height: 27px;
  color: #5b5e5d;
}

.product-size-text {
  font-size: 14px;
  color: #5b5e5d !important;
}
.filter-products-count {
  font-size: 12px;
  color: #888;
}
.filter-tags {
  font-family: Roboto;
  display: flex;
  flex-wrap: wrap;
  gap: 5px !important;
}
.extra-tag-display {
  font-family: Roboto;
  font-size: 15px;
  color: #d2042d !important;
  display: flex;
  flex-wrap: wrap;
  gap: 8px !important;
  cursor: pointer;
  text-decoration: underline;
}
.extra-tag-container.ant-row {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  width: 100%;
  margin-top: 10px;
}
.products-metric-icon {
  width: 24px;
  height: 24px;
}

.product-reach {
  font-size: 16px;
  color: #5b5e5d !important;
}

.product-type {
  font-size: 14px;
  color: #5b5e5d !important;
}

.product-last-section-detail {
  display: flex;
  justify-content: end;
}

.termsplan-section {
  display: flex;
  padding-bottom: 15px;
  align-items: flex-end;
}

.badge-icon {
  width: 15px;
}

.terms-plan-txt {
  color: #d2042d;
  font-size: 16px;
}

.bookmark-icon {
  width: 15px;
}
.search-input.ant-input-affix-wrapper .ant-input-clear-icon {
  font-size: 16px !important;
}
.search-f-loc.ant-input-affix-wrapper .ant-input-clear-icon {
  font-size: 12px !important;
}

.procduct-price-detail-section {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}

.price-text {
  color: #000;
  font-size: 17px;
  font-weight: 700 !important;
}

.per-week {
  font-size: 13px;
  color: #8e9190;
}

.details-btn {
  height: 40px;
  background-color: #d2042d;
  width: 130px;
}

.ant-pagination:not(.ant-pagination-disabled)
  .ant-pagination-item:focus-visible {
  outline: 2px solid #d2042d;
  outline-offset: 1px;
  transition:
    outline-offset 0s,
    outline 0s;
}

.ant-pagination .ant-pagination-item-active {
  font-weight: 600;
  background-color: #ffffff;
  border-color: #ffffff;
}

.ant-pagination .ant-pagination-item-active a {
  color: #d2042d;
}

.select-filter-section .ant-select-single {
  border-radius: 5px !important;
  border: 1px solid var(--Colors-Text-100, #b3b5b4) !important;
  background: #fff;
  width: 181px;

  height: 40px;
}
.select-filter-section {
  overflow-x: scroll;
}
.map-view-section {
  height: 63vh;
  overflow-y: scroll;
  padding-left: 50px;
  padding-right: 10px;
}

.selector-section {
  height: 70px;
  padding-left: 60px;
  width: 100% !important;
}

/* map view css styles */
.leaflet-container .leaflet-control-attribution {
  display: none !important;
  border: none;
}

.leaflet-top {
  top: 79% !important;
}

.leaflet-left {
  left: 93% !important;
}

.search-f-loc {
  font-family: Roboto;
  height: 40px;
}

.search-f-loc ::placeholder {
  color: var(--Colors-Text-100, #b3b5b4);
  font-size: 13px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}
.search-input.ant-input-filled:focus,
.search-input.ant-input-filled:focus-within {
  outline: 0;
  border-color: #000 !important;
  background-color: #ffffff;
}
.pagination-cnt {
  margin-top: 1% !important;
}
.filter-date-picker-from {
  height: 2rem !important;
  border: none !important;
  background-color: #f5f5f5;
  margin-left: 10px;
}
.filter-date-picker-to {
  height: 2rem !important;
  border: none !important;
  background-color: #f5f5f5;
  margin-left: 10px;
}
.filter-btn-at-map-section {
  width: 130px;
  height: 35px;
  display: flex;
}
.filter-btn-at-map-section:hover {
  color: #d2042d !important;
  border-color: #d2042d !important;
  background: #ffffff;
}

.filter-sec-at-map-txt {
  font-family: Roboto;
  font-size: 16px;
  font-weight: 500;
}

.product-page-row {
  max-width: 700;
  overflow-x: scroll;
}

.product-page-maps {
  height: 66vh;
  overflow-y: scroll;
  width: 97%;
}

@media (max-width: 1440px) {
  .search-products-sh {
    width: 50%;
    display: flex;
    justify-content: end;
    padding-right: 2rem;
  }

  .search-input {
    width: 480px !important;
  }

  .select-filter-section {
    overflow-x: scroll;
    max-width: 990px;
  }

  .filter-section-card {
    background: #fff;
    min-height: 40vh;
    border-radius: 0;
    min-width: 202px !important;
  }

  .filter-img {
    height: 20px !important;
    width: 20px !important;
  }

  .filter-txt {
    font-size: 14px;
    font-weight: 700;
  }

  .filtersection-pad {
    padding: 10;
  }

  .toggle-filters {
    color: #000;
    font-size: 13px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
  }

  .loc-truncate {
    max-width: 300px;
  }
  .map-view-section {
    height: 65vh !important;
    overflow: scroll;
    padding-left: 60px;
  }

  /* product listing card*/

  .product-card {
    width: 100%;
    height: 156px;
  }

  .product-image {
    width: 130px;
    height: 130px;
  }

  .product-bill-image {
    width: 28px;
    height: 27px;
  }

  .product-id {
    font-size: 13px;
    color: #8e9190;
  }

  .available-txt {
    font-size: 13px;
  }

  .product-availability {
    font-size: 16px;
  }

  .product-size-img {
    width: 28px;
    height: 27px;
  }

  .product-size-text {
    font-size: 16px;
  }

  .products-metric-icon {
    width: 24px;
    height: 24px;
  }

  .product-reach {
    font-size: 16px;
  }

  .product-type {
    font-size: 16px;
  }

  .product-last-section-detail {
    display: flex;
    justify-content: end;
  }

  .termsplan-section {
    display: flex;
    padding-bottom: 15px;
    align-items: flex-end;
  }

  .badge-icon {
    width: 15px;
  }

  .terms-plan-txt {
    color: #d2042d;
    font-size: 15px;
  }

  .bookmark-icon {
    width: 15px;
  }

  .procduct-price-detail-section {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
  }

  .price-text {
    color: black;
    font-size: 23px;
  }

  .per-week {
    font-size: 13px;
    color: #8e9190;
  }

  .product-card {
    width: 100%;
    height: auto;
    margin-top: 2%;
  }
}

@media (max-width: 1024px) {
  .product-page {
    padding-left: 10px;
  }

  .search-products-sh {
    padding-right: 0rem;
    margin-left: 1.6rem;
    margin-top: 0.4rem;
  }

  .find-your-text {
    width: 50%;
    padding-left: 1.6rem;
  }

  .tab-filter-section {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding-left: 5;
  }

  .filter-txt {
    font-size: 18px;
  }

  .select-filter-section {
    overflow-x: scroll;
    max-width: 895px;
  }

  .filter-selector {
    min-width: 150px;
    height: 40px;
    font-size: 16px;
    color: #0a0f0d;
  }

  .cards-container {
    width: 96vw;
  }

  .map-view-section {
    height: 90vh;
    overflow-y: scroll;
    padding-left: 27px;
  }

  /* product listing card css*/
  .selector-section {
    height: 70px;
    padding-left: 10px;
    width: 100% !important;
  }

  .product-image {
    width: 100px !important;
    height: 100px !important;
    padding: 0px 6px;
    border-radius: 11px !important;
  }

  .ant-select-dropdown .ant-select-item-option-content {
    font-size: 16px !important;
  }

  .product-page
    .ant-select-outlined:not(.ant-select-disabled):not(
      .ant-select-customize-input
    ):not(.ant-pagination-size-changer):hover
    .ant-select-selector {
    border-color: #c7cac9 !important;
  }

  .badge-icon {
    width: 14px !important;
  }

  .terms-plan-txt {
    color: #d2042d;
    font-size: 13px;
  }

  .bookmark-icon {
    width: 13px !important;
  }

  .product-availability {
    font-size: 14px;
  }
  .address-section-space-tag {
    width: 100%;
  }
  .address-section-space-tag .ant-space-item {
    width: 70% !important;
  }
  .loc-truncate {
    width: 100%;
  }
}

@media (max-width: 768px) {
  .products-container {
    height: 57vh !important;
  }

  .products-list-container {
    background: #f7f7f7;
    padding: 20px;
    height: 54vh !important;
    overflow-y: scroll;
  }

  .product-page-container {
    width: 100%;
    display: flex;
    height: 50px;
    align-items: center;
    position: relative;
  }

  .find-your-text {
    width: 100%;
    padding-left: 1.6rem;
    font-size: 13px;
  }

  .mobile-view-filter-container {
    padding: 0px 20px 0px 20px;
  }

  .advertisement-txt {
    color: #0a0f0d;
    font-size: 19px;
    font-weight: 700;
  }

  .filter-section-card {
    display: none !important;
  }

  .selector-section {
    display: none !important;
  }

  .search-products-sh {
    display: none !important;
  }

  .products-list-subcontainer {
    display: none !important;
  }

  .filter-btn {
    font-family: Roboto;
    border: none !important;
    height: 35px;
    width: 96px;
    font-size: 17px;
    font-weight: 500;
  }

  .search-input-sm {
    font-family: Roboto;
    height: 60px !important;
    border: none;
    border-radius: 8px;
    font-size: 16px;
  }
  .search-input {
    max-width: 700px !important;
    min-width: 300px !important;
    width: auto !important;
    min-height: 40px;
  }

  .search-input-sm ::placeholder {
    font-size: 16px;
  }

  .location-det-card {
    height: 60px !important;
  }

  .location-card .ant-card .ant-card-body {
    padding: 10px !important;
  }

  .current-loc-text {
    font-family: Roboto;
    font-family: Roboto;
    color: #8e9190;
    font-size: 14px;
    font-weight: 400;
  }

  .location-text {
    color: #000;
    font-size: 14px;
    font-weight: 500;
  }

  .loc-truncate {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 300px;
    display: inline-block;
  }

  .map-location-icon {
    width: 28px !important;
    height: 28px !important;
  }

  .toggle-filters {
    color: #8e9190 !important;
    font-size: 14px !important;
  }

  .cards-container {
    width: 93.5vw;
  }

  /* product listing card css*/
  .product-card {
    width: 100%;
    height: auto;
    margin-top: 2%;
  }

  .product-image {
    width: 190px !important;
    height: 140px !important;
  }

  .product-id {
    font-size: 14px;
    color: #d2042d;
  }

  .available-txt {
    font-size: 15px;
    color: #8e9190;
  }

  .middle-specification {
    margin-top: 0.7rem;
    background-color: #f8f8f8 !important;
    display: flex;
    height: auto;
    padding: 21px 34px 20px 34px;
    justify-content: space-between;
  }

  .product-availability {
    font-size: 16px;
    font-weight: 500;
  }

  .available-container {
    padding-top: 20px !important;
  }

  .product-size-text {
    font-size: 15px;
  }

  .product-reach {
    font-size: 15px;
  }

  .product-type {
    font-size: 15px;
  }

  .product-last-section-detail {
    display: flex;
    justify-content: end;
    padding-top: 10px;
    align-items: baseline;
  }

  .product-page
    .ant-btn-variant-outlined:not(:disabled):not(.ant-btn-disabled):hover {
    background-color: none;
    border: none;
    width: none !important;
    height: 50px;
    margin-top: 0rem !important;
    color: rgb(12, 12, 12);
  }

  .ant-btn:not(:disabled):focus-visible {
    outline: none !important;
    outline-offset: 01px !important;
    transition: none !important;
  }

  .price-section {
    display: flex;
    align-items: flex-end;
  }

  .navigation-icon {
    width: 15px !important;
  }

  .miles-text {
    color: #8e9190;
    font-size: 15px;
  }

  .bookmark-icon {
    margin-left: 8rem !important;
    width: 17px !important;
  }

  .price-text {
    color: black;
    font-size: 17px;
  }

  .ant-pagination:not(.ant-pagination-disabled)
    .ant-pagination-item:focus-visible {
    outline: 1px solid #d2042d;
    outline-offset: 1px;
    transition:
      outline-offset 0s,
      outline 0s;
  }

  .ant-pagination .ant-pagination-item-active {
    font-weight: 600;
    background-color: #ffffff;
    border-color: #fff;
  }

  .ant-pagination .ant-pagination-item-active a {
    color: #d2042d;
  }

  .product-last-section-detail-map {
    display: none;
  }

  .map-view-section {
    display: none !important;
  }
}

@media (max-width: 430px) {
  .product-page-container {
    height: 60px;
  }
  .products-list-container {
    background: #f7f7f7;
    padding: 5px;
    height: 57vh !important;
    overflow-y: scroll;
  }
  .toggle-filters {
    color: #8e9190 !important;
    font-size: 12px !important;
  }
  .find-your-text {
    width: 100%;
    padding-left: 0.6rem;
    padding-top: 0.5rem;
    font-size: 13px;
  }

  .product-page .ant-card .ant-card-body {
    padding: 14px;
    border-radius: 18 0 8px 8px;
  }

  .advertisement-txt {
    color: #0a0f0d;
    font-size: 17px;
    font-weight: 700;
  }

  .mobile-view-filter-container {
    padding: 0px 10px 0px 7px;
  }

  .filter-btn {
    font-family: Roboto;
    border: none !important;
    height: 40px;
    width: 86px;
    font-size: 16px !important;
    color: #000;
    font-weight: 500;
  }

  .product-page
    .ant-btn-variant-outlined:not(:disabled):not(.ant-btn-disabled):hover {
    background-color: none;
    border: none;
    width: none !important;
    height: 40px;
    margin-top: 0rem !important;
    color: rgb(12, 12, 12);
  }

  .search-input-sm {
    font-family: Roboto;
    height: 40px !important;
    border: none;
    border-radius: 8px;
    font-size: 16px;
  }

  .current-loc-text {
    font-family: Roboto;
    color: #8e9190;
    font-size: 13px;
    font-weight: 400;
  }

  .location-text {
    color: #000;
    font-size: 13px;
    font-weight: 500;
  }

  .map-location-icon {
    width: 24px !important;
    height: 24px !important;
  }

  .map-location-icon {
    width: 24px !important;
    height: 24px !important;
  }

  .toggle-filters {
    color: #8e9190 !important;
    font-size: 13px !important;
  }

  .loc-truncate {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 150px;
    display: inline-block;
  }

  /** product listing card css*/

  .product-image {
    width: 120px !important;
    height: 104px !important;
  }

  .product-id {
    font-size: 13px !important;
    color: #d2042d;
    font-weight: 500;
  }

  .bookmark-icon {
    margin-left: 41px !important;
    width: 17px !important;
  }

  .available-txt {
    font-size: 13px;
    color: #8e9190;
  }

  .product-availability {
    font-size: 13px;
    font-weight: 600;
  }

  .middle-specification {
    display: flex;
    height: auto;
    padding: 21px 0px 20px 0px !important;
    justify-content: space-evenly;
    flex-shrink: 0;
  }

  .product-size-img {
    width: 20px;
    height: 19px;
  }

  .product-size-text {
    font-size: 13px;
  }

  .products-metric-icon {
    width: 20px;
    height: 20px;
  }

  .product-reach {
    font-size: 13px;
  }

  .product-type {
    font-size: 13px;
  }

  .navigation-icon {
    width: 13px !important;
  }

  .miles-text {
    color: #8e9190;
    font-size: 13px;
  }

  .price-text {
    color: black;
    font-size: 19px;
    font-weight: 700 !important;
  }
}

@media (max-width: 375px) {
  /** product listing card css*/

  .product-image {
    width: 110px !important;
    height: 100px !important;
    border-radius: 10px !important;
  }
  .advertisement-txt {
    color: #0a0f0d;
    font-size: 17px;
    font-weight: 700;
  }
  .available-container {
    padding-top: 15px !important;
  }

  .bookmark-icon {
    margin-left: 18px !important;
    width: 17px !important;
  }

  .middle-specification {
    display: flex;
    height: auto;
    padding: 15px 0px 19px 0px !important;
    justify-content: space-evenly;
    flex-shrink: 0;
  }

  .toggle-filters {
    color: #8e9190 !important;
    font-size: 10px !important;
  }
}

@media (max-width: 360px) {
  .loc-truncate {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 120px;
    display: inline-block;
  }

  .location-text {
    color: #000;
    font-size: 12px;
    font-weight: 500;
  }

  .current-loc-text {
    color: #8e9190;
    font-size: 12px;
    font-weight: 400;
  }

  .location-card .ant-card .ant-card-body {
    padding: 5px !important;
  }

  .bookmark-icon {
    margin-left: 8px !important;
    width: 17px !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/layout/products/ProductsPage.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,aAAa;EACb,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,oBAAoB;AACtB;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,6BAA6B;AAC/B;AACA;EACE,6BAA6B;EAC7B,YAAY;EACZ,YAAY;AACd;AACA;EACE,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;AACzB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,6BAA6B;EAC7B,aAAa;AACf;;AAEA;EACE,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;AACA;EACE,oCAAoC;AACtC;AACA;EACE,oCAAoC;EACpC,sBAAsB;AACxB;AACA;EACE,kCAAkC;EAClC,oCAAoC;AACtC;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,yBAAyB;EACzB,iBAAiB;AACnB;AACA;EACE,yBAAyB;EACzB,WAAW;EACX,cAAc;AAChB;AACA;EACE,oCAAoC;EACpC,sBAAsB;EACtB,yBAAyB;AAC3B;AACA;EACE,yBAAyB;EACzB,WAAW;EACX,yBAAyB;AAC3B;AACA;EACE,oCAAoC;EACpC,sBAAsB;EACtB,cAAc;AAChB;AACA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,+BAA+B;EAC/B,8BAA8B;AAChC;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,oCAAoC;EACpC,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,aAAa;EACb,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,yBAAyB;EACzB,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,YAAY;EACZ,yBAAyB;EACzB,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,YAAY;EACZ,kBAAkB;EAClB,8BAA8B;EAC9B,kBAAkB;EAClB,oBAAoB;EACpB,uBAAuB;EACvB,mBAAmB;EACnB,QAAQ;EACR,sBAAsB;EACtB,0BAA0B;EAC1B,qBAAqB;EACrB,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,gBAAgB;EAChB,YAAY;AACd;AACA;EACE,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,qBAAqB;EACrB,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,uBAAuB;EACvB,2BAA2B;EAC3B,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE;IACE,mBAAmB;IACnB,eAAe;IACf,WAAW;EACb;EACA;IACE,0BAA0B;EAC5B;AACF;AACA;EACE;IACE,mBAAmB;IACnB,aAAa;IACb,uBAAuB;IACvB,2BAA2B;IAC3B,2BAA2B;IAC3B,kBAAkB;EACpB;EACA;IACE,WAAW;EACb;AACF;AACA;EACE,cAAc;EACd,8BAA8B;AAChC;AACA;EACE,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,0BAA0B;;EAE1B,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,0BAA0B;EAC1B,gBAAgB;AAClB;AACA;EACE,sCAAsC;EACtC,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,sCAAsC;EACtC,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,4BAA4B;EAC5B,0BAA0B;AAC5B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,yBAAyB;EACzB,eAAe;AACjB;AACA;EACE,aAAa;EACb,WAAW;EACX,WAAW;EACX,eAAe;EACf,aAAa;AACf;AACA;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;EAChB,qBAAqB;AACvB;AACA;EACE,sCAAsC;EACtC,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,yBAAyB;AAC3B;AACA;EACE,eAAe;EACf,WAAW;AACb;AACA;EACE,mBAAmB;EACnB,aAAa;EACb,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,eAAe;EACf,0BAA0B;AAC5B;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,yBAAyB;EACzB,YAAY;AACd;;AAEA;;EAEE,0BAA0B;EAC1B,mBAAmB;EACnB;;cAEY;AACd;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,6BAA6B;EAC7B,4DAA4D;EAC5D,gBAAgB;EAChB,YAAY;;EAEZ,YAAY;AACd;AACA;EACE,kBAAkB;AACpB;AACA;EACE,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA,wBAAwB;AACxB;EACE,wBAAwB;EACxB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,sCAAsC;EACtC,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;;EAEE,UAAU;EACV,6BAA6B;EAC7B,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,uBAAuB;EACvB,uBAAuB;EACvB,yBAAyB;EACzB,iBAAiB;AACnB;AACA;EACE,uBAAuB;EACvB,uBAAuB;EACvB,yBAAyB;EACzB,iBAAiB;AACnB;AACA;EACE,YAAY;EACZ,YAAY;EACZ,aAAa;AACf;AACA;EACE,yBAAyB;EACzB,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE;IACE,UAAU;IACV,aAAa;IACb,oBAAoB;IACpB,mBAAmB;EACrB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;IAChB,2BAA2B;EAC7B;;EAEA;IACE,uBAAuB;IACvB,sBAAsB;EACxB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;IACX,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;EAClB;EACA;IACE,uBAAuB;IACvB,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA,wBAAwB;;EAExB;IACE,WAAW;IACX,aAAa;EACf;;EAEA;IACE,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,eAAe;IACf,cAAc;EAChB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,oBAAoB;EACtB;;EAEA;IACE,aAAa;IACb,oBAAoB;IACpB,qBAAqB;EACvB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,cAAc;IACd,eAAe;EACjB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,qBAAqB;EACvB;;EAEA;IACE,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,cAAc;EAChB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,cAAc;EAChB;AACF;;AAEA;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,UAAU;IACV,oBAAoB;EACtB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,mBAAmB;IACnB,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,cAAc;EAChB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;EACpB;;EAEA,4BAA4B;EAC5B;IACE,YAAY;IACZ,kBAAkB;IAClB,sBAAsB;EACxB;;EAEA;IACE,uBAAuB;IACvB,wBAAwB;IACxB,gBAAgB;IAChB,8BAA8B;EAChC;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;;;;;IAKE,gCAAgC;EAClC;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,cAAc;IACd,eAAe;EACjB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,eAAe;EACjB;EACA;IACE,WAAW;EACb;EACA;IACE,qBAAqB;EACvB;EACA;IACE,WAAW;EACb;AACF;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,mBAAmB;IACnB,aAAa;IACb,uBAAuB;IACvB,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,aAAa;IACb,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,oBAAoB;IACpB,eAAe;EACjB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,cAAc;IACd,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;IACZ,WAAW;IACX,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;IACZ,kBAAkB;IAClB,eAAe;EACjB;EACA;IACE,2BAA2B;IAC3B,2BAA2B;IAC3B,sBAAsB;IACtB,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,mBAAmB;IACnB,mBAAmB;IACnB,cAAc;IACd,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;IACvB,gBAAgB;IAChB,qBAAqB;EACvB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,yBAAyB;IACzB,0BAA0B;EAC5B;;EAEA;IACE,aAAa;EACf;;EAEA,4BAA4B;EAC5B;IACE,WAAW;IACX,YAAY;IACZ,cAAc;EAChB;;EAEA;IACE,uBAAuB;IACvB,wBAAwB;EAC1B;;EAEA;IACE,eAAe;IACf,cAAc;EAChB;;EAEA;IACE,eAAe;IACf,cAAc;EAChB;;EAEA;IACE,kBAAkB;IAClB,oCAAoC;IACpC,aAAa;IACb,YAAY;IACZ,4BAA4B;IAC5B,8BAA8B;EAChC;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,oBAAoB;IACpB,iBAAiB;IACjB,qBAAqB;EACvB;;EAEA;;IAEE,sBAAsB;IACtB,YAAY;IACZ,sBAAsB;IACtB,YAAY;IACZ,2BAA2B;IAC3B,sBAAsB;EACxB;;EAEA;IACE,wBAAwB;IACxB,+BAA+B;IAC/B,2BAA2B;EAC7B;;EAEA;IACE,aAAa;IACb,qBAAqB;EACvB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,cAAc;IACd,eAAe;EACjB;;EAEA;IACE,4BAA4B;IAC5B,sBAAsB;EACxB;;EAEA;IACE,YAAY;IACZ,eAAe;EACjB;;EAEA;;IAEE,0BAA0B;IAC1B,mBAAmB;IACnB;;gBAEY;EACd;;EAEA;IACE,gBAAgB;IAChB,yBAAyB;IACzB,kBAAkB;EACpB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,YAAY;EACd;EACA;IACE,mBAAmB;IACnB,YAAY;IACZ,uBAAuB;IACvB,kBAAkB;EACpB;EACA;IACE,yBAAyB;IACzB,0BAA0B;EAC5B;EACA;IACE,WAAW;IACX,oBAAoB;IACpB,mBAAmB;IACnB,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,2BAA2B;EAC7B;;EAEA;IACE,cAAc;IACd,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;IACZ,WAAW;IACX,0BAA0B;IAC1B,WAAW;IACX,gBAAgB;EAClB;;EAEA;;IAEE,sBAAsB;IACtB,YAAY;IACZ,sBAAsB;IACtB,YAAY;IACZ,2BAA2B;IAC3B,sBAAsB;EACxB;;EAEA;IACE,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;IACZ,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,mBAAmB;IACnB,cAAc;IACd,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,yBAAyB;IACzB,0BAA0B;EAC5B;;EAEA;IACE,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;IACvB,gBAAgB;IAChB,qBAAqB;EACvB;;EAEA,6BAA6B;;EAE7B;IACE,uBAAuB;IACvB,wBAAwB;EAC1B;;EAEA;IACE,0BAA0B;IAC1B,cAAc;IACd,gBAAgB;EAClB;;EAEA;IACE,4BAA4B;IAC5B,sBAAsB;EACxB;;EAEA;IACE,eAAe;IACf,cAAc;EAChB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,YAAY;IACZ,qCAAqC;IACrC,6BAA6B;IAC7B,cAAc;EAChB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,cAAc;IACd,eAAe;EACjB;;EAEA;IACE,YAAY;IACZ,eAAe;IACf,2BAA2B;EAC7B;AACF;;AAEA;EACE,6BAA6B;;EAE7B;IACE,uBAAuB;IACvB,wBAAwB;IACxB,8BAA8B;EAChC;EACA;IACE,cAAc;IACd,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,4BAA4B;EAC9B;;EAEA;IACE,4BAA4B;IAC5B,sBAAsB;EACxB;;EAEA;IACE,aAAa;IACb,YAAY;IACZ,qCAAqC;IACrC,6BAA6B;IAC7B,cAAc;EAChB;;EAEA;IACE,yBAAyB;IACzB,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;IACvB,gBAAgB;IAChB,qBAAqB;EACvB;;EAEA;IACE,WAAW;IACX,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,cAAc;IACd,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,2BAA2B;IAC3B,sBAAsB;EACxB;AACF","sourcesContent":[".product-page-container {\n  width: 100%;\n  display: flex;\n  height: 90px;\n  align-items: center;\n  position: relative;\n}\n\n.find-your-text {\n  width: 50%;\n  padding-left: 4.2rem;\n}\n.ant-collapse .ant-collapse-content > .ant-collapse-content-box {\n  padding: 16px 4px 12px 16px;\n}\n.search-input {\n  font-family: Roboto;\n  width: 583px !important;\n  height: 50px;\n}\n\n.search-input .ant-input-prefix {\n  margin-right: 1rem;\n}\n.search-f-loc .ant-input-prefix {\n  margin-right: 1rem;\n}\n\n.search-input.ant-input-filled {\n  background-color: #fff !important;\n}\n\n.search-input.ant-input-filled:focus {\n  border-color: #000 !important;\n}\n.search-input:hover {\n  border-color: #000 !important;\n  width: 583px;\n  height: 50px;\n}\n.price-filter-input-field {\n  font-size: 12px;\n}\n\n.single-calendar .ant-picker-dropdown .ant-picker-content th {\n  height: 36px;\n  color: #a8a5a6 !important;\n  vertical-align: middle;\n}\n\n.collapse-container-product.ant-collapse-borderless {\n  background-color: white;\n}\n.collapse-container-productType.ant-collapse-borderless {\n  background-color: white;\n}\n.ant-collapse-borderless > .ant-collapse-item > .ant-collapse-content {\n  background-color: transparent;\n  border-top: 0;\n}\n\n.time-square-billboard-table ::-webkit-scrollbar-thumb {\n  background: #ea8c9e !important;\n  border-radius: 10px;\n}\n\n.collapse-container-product.ant-collapse > .ant-collapse-item {\n  border-bottom: none;\n}\n\n.collapse-container-productType.ant-collapse > .ant-collapse-item {\n  border-bottom: none;\n}\n.ant-switch-checked {\n  background-color: #d2042d !important;\n}\n.filters-apply-btn {\n  background-color: #d2042d !important;\n  color: #fff !important;\n}\n.filters-apply-btn:hover {\n  border-color: #d2042d !important  ;\n  background-color: #d2042d !important;\n}\n\n.advertisement-txt {\n  font-family: Roboto;\n  color: #0a0f0d;\n  font-size: 19px;\n  font-weight: 600;\n}\n\n.ant-switch-checked .ant-switch-handle {\n  border-color: #ffffff;\n}\n\n.toggle-filters {\n  font-family: Roboto;\n  color: #000;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: normal;\n}\n.filters-count-badge {\n  color: #fff;\n  color: #d2042d !important;\n  margin-left: 10px;\n}\n.cancel-filter-modal {\n  background-color: #5b5e5d;\n  color: #fff;\n  border: \"none\";\n}\n.cancel-filter-modal:hover {\n  background-color: #5b5e5d !important;\n  color: #fff !important;\n  border: \"none\" !important;\n}\n.clear-filter-modal {\n  background-color: #d2042d;\n  color: #fff;\n  border: \"none\" !important;\n}\n.clear-filter-modal:hover {\n  background-color: #d2042d !important;\n  color: #fff !important;\n  border: \"none\";\n}\n.product-sh {\n  height: 90px;\n}\n\n.sh-row {\n  height: 90px;\n  margin-left: 4.5rem;\n}\n\n.search-input-con {\n  display: flex;\n  align-items: end !important;\n  justify-content: end !important;\n  padding-right: 2rem !important;\n}\n\n.product-search-btn {\n  height: 50px;\n  width: 170px;\n  background-color: #d2042d;\n  margin-left: 10px;\n}\n\n.product-search-btn:hover {\n  height: 50px;\n  width: 170px;\n  background-color: #d2042d !important;\n  margin-left: 10px;\n  border: none;\n}\n\n.search-txt {\n  font-family: Roboto;\n  color: #fff;\n  font-size: 16px;\n  font-weight: 600;\n}\n\n.filter-section {\n  height: 100px;\n  width: 100%;\n  position: fixed;\n}\n\n.filter-section-card {\n  background: #fff;\n  min-height: 40vh;\n  border-radius: 0;\n  min-width: 20%;\n}\n\n.search-products-sh {\n  width: 50%;\n  display: flex;\n  justify-content: end;\n  padding-right: 2rem;\n}\n\n.filter-img {\n  height: 24px;\n  width: 24px;\n}\n\n.filter-txt {\n  font-family: Roboto;\n  font-size: 16px;\n  font-weight: 700;\n}\n\n.filtersection-pad {\n  padding: 10;\n}\n\n.filter-reset-btn {\n  font-family: Roboto;\n  float: right;\n  color: #d2042d !important;\n  font-weight: 500;\n  font-size: 15px;\n}\n.filter-reset-btn:hover {\n  float: right;\n  color: #d2042d !important;\n  font-weight: 500;\n  font-size: 15px;\n}\n.create-campaign-bulk-btn {\n  height: 35px;\n  padding: 12px 20px;\n  background: #d2042d !important;\n  border-radius: 5px;\n  display: inline-flex;\n  justify-content: center;\n  align-items: center;\n  gap: 8px;\n  color: #fff !important;\n  font-size: 14px !important;\n  font-family: \"Roboto\";\n  font-weight: 500;\n}\n.collapse-container-product {\n  border: none;\n  overflow-y: auto;\n  height: 68vh;\n}\n.collapse-container-productType {\n  border: none;\n}\n\n.collapse-pannel-container {\n  font-family: Roboto;\n  font-size: 14px;\n  color: #0a0f0d;\n  font-weight: 600;\n}\n\n.view-more-loc {\n  display: \"block\";\n  margin-top: \"20px\";\n  margin-left: \"27px\";\n  color: \"#d2042d\";\n  font-family: \"Roboto\";\n  font-size: \"16px\";\n  font-weight: \"500\";\n  cursor: \"pointer\";\n}\n\n.collapse-pannel-checkbox {\n  display: flex;\n  flex-direction: column;\n  gap: 8px !important;\n}\n\n.products-list-container {\n  background: #f7f7f7;\n  padding: 20px;\n  height: auto !important;\n  min-height: 60vh !important;\n  max-height: 66vh !important;\n  overflow-y: scroll;\n}\n\n@media (max-width: 1370px) {\n  .product-card-city {\n    font-family: Roboto;\n    font-size: 14px;\n    color: #000;\n  }\n  .product-availability {\n    font-size: 14px !important;\n  }\n}\n@media (max-width: 1280px) {\n  .products-list-container {\n    background: #f7f7f7;\n    padding: 20px;\n    height: auto !important;\n    min-height: 60vh !important;\n    max-height: 63vh !important;\n    overflow-y: scroll;\n  }\n  .cards-container {\n    width: 100%;\n  }\n}\n.ant-pagination .ant-pagination-item-active:hover {\n  color: #d2042d;\n  border-color: unset !important;\n}\n.map-view-section {\n  height: 30vh;\n  overflow-y: scroll;\n  padding-left: 50px;\n  padding-right: 10px;\n}\n.product-page-maps {\n  height: 50vh;\n  overflow-y: scroll;\n}\n\n.ant-pagination .ant-pagination-item-active:hover a {\n  color: #d2042d;\n  border-color: none;\n}\n\n.products-list-subcontainer {\n  margin-bottom: 0px;\n  width: 100%;\n}\n\n.location-icon-c {\n  display: flex;\n  justify-content: center;\n}\n\n.location-text {\n  font-family: Roboto;\n  font-size: 13px;\n  color: #8e9190;\n}\n\n.address-text {\n  font-family: Roboto;\n  font-size: 14px;\n  font-weight: 400;\n}\n\n.change-btn-text {\n  color: #d2042d;\n  text-decoration: underline;\n\n  font-weight: 500;\n  font-size: 16px;\n}\n\n.change-btn-text :hover {\n  color: #d2042d;\n  text-decoration: underline;\n  font-weight: 500;\n}\n.collapse-pannel-checkbox-label {\n  color: var(--Colors-Text-500, #0a0f0d);\n  font-family: Roboto;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 1.5rem;\n  display: flex;\n  align-items: center;\n}\n.products-type-check-box-label-names {\n  color: var(--Colors-Text-500, #0a0f0d);\n  font-family: Roboto;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 1.5rem;\n}\n.toggle-filter-section {\n  display: flex;\n  justify-content: flex-end;\n  padding-right: 42px;\n}\n\n.cards-container {\n  width: 100%;\n}\n\n.product-page .ant-card .ant-card-body {\n  padding-top: 15px !important;\n  border-radius: 0 0 8px 8px;\n}\n\n.product-image-div {\n  padding: 0px 0px 0px 0px;\n}\n\n.product-image {\n  width: 140px;\n  height: 140px;\n  border-radius: 5px !important;\n}\n\n.vertical-line {\n  margin: \"0px auto\";\n  width: 1px;\n  height: 2cm;\n  background-color: #b3b5b4;\n  margin-top: 5px;\n}\n.product-page .ant-divider-horizontal {\n  display: flex;\n  clear: both;\n  width: 100%;\n  min-width: 100%;\n  margin: 0px 0;\n}\n.products-container {\n  height: 65vh;\n  overflow-y: auto;\n}\n\n.loc-truncate {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  max-width: 400px;\n  display: inline-block;\n}\n.product-availble-count {\n  color: var(--Colors-Text-400, #3b3f3d);\n  font-family: Roboto;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 1.5rem;\n}\n.product-id {\n  font-size: 13px;\n  color: #8e9190;\n}\n\n.available-txt {\n  font-size: 13px;\n}\n\n.product-availability {\n  font-size: 14px;\n}\n\n.product-size-img {\n  width: 28px;\n  height: 27px;\n  color: #5b5e5d;\n}\n\n.product-size-text {\n  font-size: 14px;\n  color: #5b5e5d !important;\n}\n.filter-products-count {\n  font-size: 12px;\n  color: #888;\n}\n.filter-tags {\n  font-family: Roboto;\n  display: flex;\n  flex-wrap: wrap;\n  gap: 5px !important;\n}\n.extra-tag-display {\n  font-family: Roboto;\n  font-size: 15px;\n  color: #d2042d !important;\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px !important;\n  cursor: pointer;\n  text-decoration: underline;\n}\n.extra-tag-container.ant-row {\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-end;\n  align-items: center;\n  width: 100%;\n  margin-top: 10px;\n}\n.products-metric-icon {\n  width: 24px;\n  height: 24px;\n}\n\n.product-reach {\n  font-size: 16px;\n  color: #5b5e5d !important;\n}\n\n.product-type {\n  font-size: 14px;\n  color: #5b5e5d !important;\n}\n\n.product-last-section-detail {\n  display: flex;\n  justify-content: end;\n}\n\n.termsplan-section {\n  display: flex;\n  padding-bottom: 15px;\n  align-items: flex-end;\n}\n\n.badge-icon {\n  width: 15px;\n}\n\n.terms-plan-txt {\n  color: #d2042d;\n  font-size: 16px;\n}\n\n.bookmark-icon {\n  width: 15px;\n}\n.search-input.ant-input-affix-wrapper .ant-input-clear-icon {\n  font-size: 16px !important;\n}\n.search-f-loc.ant-input-affix-wrapper .ant-input-clear-icon {\n  font-size: 12px !important;\n}\n\n.procduct-price-detail-section {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n}\n\n.price-text {\n  color: #000;\n  font-size: 17px;\n  font-weight: 700 !important;\n}\n\n.per-week {\n  font-size: 13px;\n  color: #8e9190;\n}\n\n.details-btn {\n  height: 40px;\n  background-color: #d2042d;\n  width: 130px;\n}\n\n.ant-pagination:not(.ant-pagination-disabled)\n  .ant-pagination-item:focus-visible {\n  outline: 2px solid #d2042d;\n  outline-offset: 1px;\n  transition:\n    outline-offset 0s,\n    outline 0s;\n}\n\n.ant-pagination .ant-pagination-item-active {\n  font-weight: 600;\n  background-color: #ffffff;\n  border-color: #ffffff;\n}\n\n.ant-pagination .ant-pagination-item-active a {\n  color: #d2042d;\n}\n\n.select-filter-section .ant-select-single {\n  border-radius: 5px !important;\n  border: 1px solid var(--Colors-Text-100, #b3b5b4) !important;\n  background: #fff;\n  width: 181px;\n\n  height: 40px;\n}\n.select-filter-section {\n  overflow-x: scroll;\n}\n.map-view-section {\n  height: 63vh;\n  overflow-y: scroll;\n  padding-left: 50px;\n  padding-right: 10px;\n}\n\n.selector-section {\n  height: 70px;\n  padding-left: 60px;\n  width: 100% !important;\n}\n\n/* map view css styles */\n.leaflet-container .leaflet-control-attribution {\n  display: none !important;\n  border: none;\n}\n\n.leaflet-top {\n  top: 79% !important;\n}\n\n.leaflet-left {\n  left: 93% !important;\n}\n\n.search-f-loc {\n  font-family: Roboto;\n  height: 40px;\n}\n\n.search-f-loc ::placeholder {\n  color: var(--Colors-Text-100, #b3b5b4);\n  font-size: 13px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n}\n.search-input.ant-input-filled:focus,\n.search-input.ant-input-filled:focus-within {\n  outline: 0;\n  border-color: #000 !important;\n  background-color: #ffffff;\n}\n.pagination-cnt {\n  margin-top: 1% !important;\n}\n.filter-date-picker-from {\n  height: 2rem !important;\n  border: none !important;\n  background-color: #f5f5f5;\n  margin-left: 10px;\n}\n.filter-date-picker-to {\n  height: 2rem !important;\n  border: none !important;\n  background-color: #f5f5f5;\n  margin-left: 10px;\n}\n.filter-btn-at-map-section {\n  width: 130px;\n  height: 35px;\n  display: flex;\n}\n.filter-btn-at-map-section:hover {\n  color: #d2042d !important;\n  border-color: #d2042d !important;\n  background: #ffffff;\n}\n\n.filter-sec-at-map-txt {\n  font-family: Roboto;\n  font-size: 16px;\n  font-weight: 500;\n}\n\n.product-page-row {\n  max-width: 700;\n  overflow-x: scroll;\n}\n\n.product-page-maps {\n  height: 66vh;\n  overflow-y: scroll;\n  width: 97%;\n}\n\n@media (max-width: 1440px) {\n  .search-products-sh {\n    width: 50%;\n    display: flex;\n    justify-content: end;\n    padding-right: 2rem;\n  }\n\n  .search-input {\n    width: 480px !important;\n  }\n\n  .select-filter-section {\n    overflow-x: scroll;\n    max-width: 990px;\n  }\n\n  .filter-section-card {\n    background: #fff;\n    min-height: 40vh;\n    border-radius: 0;\n    min-width: 202px !important;\n  }\n\n  .filter-img {\n    height: 20px !important;\n    width: 20px !important;\n  }\n\n  .filter-txt {\n    font-size: 14px;\n    font-weight: 700;\n  }\n\n  .filtersection-pad {\n    padding: 10;\n  }\n\n  .toggle-filters {\n    color: #000;\n    font-size: 13px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: normal;\n  }\n\n  .loc-truncate {\n    max-width: 300px;\n  }\n  .map-view-section {\n    height: 65vh !important;\n    overflow: scroll;\n    padding-left: 60px;\n  }\n\n  /* product listing card*/\n\n  .product-card {\n    width: 100%;\n    height: 156px;\n  }\n\n  .product-image {\n    width: 130px;\n    height: 130px;\n  }\n\n  .product-bill-image {\n    width: 28px;\n    height: 27px;\n  }\n\n  .product-id {\n    font-size: 13px;\n    color: #8e9190;\n  }\n\n  .available-txt {\n    font-size: 13px;\n  }\n\n  .product-availability {\n    font-size: 16px;\n  }\n\n  .product-size-img {\n    width: 28px;\n    height: 27px;\n  }\n\n  .product-size-text {\n    font-size: 16px;\n  }\n\n  .products-metric-icon {\n    width: 24px;\n    height: 24px;\n  }\n\n  .product-reach {\n    font-size: 16px;\n  }\n\n  .product-type {\n    font-size: 16px;\n  }\n\n  .product-last-section-detail {\n    display: flex;\n    justify-content: end;\n  }\n\n  .termsplan-section {\n    display: flex;\n    padding-bottom: 15px;\n    align-items: flex-end;\n  }\n\n  .badge-icon {\n    width: 15px;\n  }\n\n  .terms-plan-txt {\n    color: #d2042d;\n    font-size: 15px;\n  }\n\n  .bookmark-icon {\n    width: 15px;\n  }\n\n  .procduct-price-detail-section {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-end;\n  }\n\n  .price-text {\n    color: black;\n    font-size: 23px;\n  }\n\n  .per-week {\n    font-size: 13px;\n    color: #8e9190;\n  }\n\n  .product-card {\n    width: 100%;\n    height: auto;\n    margin-top: 2%;\n  }\n}\n\n@media (max-width: 1024px) {\n  .product-page {\n    padding-left: 10px;\n  }\n\n  .search-products-sh {\n    padding-right: 0rem;\n    margin-left: 1.6rem;\n    margin-top: 0.4rem;\n  }\n\n  .find-your-text {\n    width: 50%;\n    padding-left: 1.6rem;\n  }\n\n  .tab-filter-section {\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n    align-items: center;\n    padding-left: 5;\n  }\n\n  .filter-txt {\n    font-size: 18px;\n  }\n\n  .select-filter-section {\n    overflow-x: scroll;\n    max-width: 895px;\n  }\n\n  .filter-selector {\n    min-width: 150px;\n    height: 40px;\n    font-size: 16px;\n    color: #0a0f0d;\n  }\n\n  .cards-container {\n    width: 96vw;\n  }\n\n  .map-view-section {\n    height: 90vh;\n    overflow-y: scroll;\n    padding-left: 27px;\n  }\n\n  /* product listing card css*/\n  .selector-section {\n    height: 70px;\n    padding-left: 10px;\n    width: 100% !important;\n  }\n\n  .product-image {\n    width: 100px !important;\n    height: 100px !important;\n    padding: 0px 6px;\n    border-radius: 11px !important;\n  }\n\n  .ant-select-dropdown .ant-select-item-option-content {\n    font-size: 16px !important;\n  }\n\n  .product-page\n    .ant-select-outlined:not(.ant-select-disabled):not(\n      .ant-select-customize-input\n    ):not(.ant-pagination-size-changer):hover\n    .ant-select-selector {\n    border-color: #c7cac9 !important;\n  }\n\n  .badge-icon {\n    width: 14px !important;\n  }\n\n  .terms-plan-txt {\n    color: #d2042d;\n    font-size: 13px;\n  }\n\n  .bookmark-icon {\n    width: 13px !important;\n  }\n\n  .product-availability {\n    font-size: 14px;\n  }\n  .address-section-space-tag {\n    width: 100%;\n  }\n  .address-section-space-tag .ant-space-item {\n    width: 70% !important;\n  }\n  .loc-truncate {\n    width: 100%;\n  }\n}\n\n@media (max-width: 768px) {\n  .products-container {\n    height: 57vh !important;\n  }\n\n  .products-list-container {\n    background: #f7f7f7;\n    padding: 20px;\n    height: 54vh !important;\n    overflow-y: scroll;\n  }\n\n  .product-page-container {\n    width: 100%;\n    display: flex;\n    height: 50px;\n    align-items: center;\n    position: relative;\n  }\n\n  .find-your-text {\n    width: 100%;\n    padding-left: 1.6rem;\n    font-size: 13px;\n  }\n\n  .mobile-view-filter-container {\n    padding: 0px 20px 0px 20px;\n  }\n\n  .advertisement-txt {\n    color: #0a0f0d;\n    font-size: 19px;\n    font-weight: 700;\n  }\n\n  .filter-section-card {\n    display: none !important;\n  }\n\n  .selector-section {\n    display: none !important;\n  }\n\n  .search-products-sh {\n    display: none !important;\n  }\n\n  .products-list-subcontainer {\n    display: none !important;\n  }\n\n  .filter-btn {\n    font-family: Roboto;\n    border: none !important;\n    height: 35px;\n    width: 96px;\n    font-size: 17px;\n    font-weight: 500;\n  }\n\n  .search-input-sm {\n    font-family: Roboto;\n    height: 60px !important;\n    border: none;\n    border-radius: 8px;\n    font-size: 16px;\n  }\n  .search-input {\n    max-width: 700px !important;\n    min-width: 300px !important;\n    width: auto !important;\n    min-height: 40px;\n  }\n\n  .search-input-sm ::placeholder {\n    font-size: 16px;\n  }\n\n  .location-det-card {\n    height: 60px !important;\n  }\n\n  .location-card .ant-card .ant-card-body {\n    padding: 10px !important;\n  }\n\n  .current-loc-text {\n    font-family: Roboto;\n    font-family: Roboto;\n    color: #8e9190;\n    font-size: 14px;\n    font-weight: 400;\n  }\n\n  .location-text {\n    color: #000;\n    font-size: 14px;\n    font-weight: 500;\n  }\n\n  .loc-truncate {\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    max-width: 300px;\n    display: inline-block;\n  }\n\n  .map-location-icon {\n    width: 28px !important;\n    height: 28px !important;\n  }\n\n  .toggle-filters {\n    color: #8e9190 !important;\n    font-size: 14px !important;\n  }\n\n  .cards-container {\n    width: 93.5vw;\n  }\n\n  /* product listing card css*/\n  .product-card {\n    width: 100%;\n    height: auto;\n    margin-top: 2%;\n  }\n\n  .product-image {\n    width: 190px !important;\n    height: 140px !important;\n  }\n\n  .product-id {\n    font-size: 14px;\n    color: #d2042d;\n  }\n\n  .available-txt {\n    font-size: 15px;\n    color: #8e9190;\n  }\n\n  .middle-specification {\n    margin-top: 0.7rem;\n    background-color: #f8f8f8 !important;\n    display: flex;\n    height: auto;\n    padding: 21px 34px 20px 34px;\n    justify-content: space-between;\n  }\n\n  .product-availability {\n    font-size: 16px;\n    font-weight: 500;\n  }\n\n  .available-container {\n    padding-top: 20px !important;\n  }\n\n  .product-size-text {\n    font-size: 15px;\n  }\n\n  .product-reach {\n    font-size: 15px;\n  }\n\n  .product-type {\n    font-size: 15px;\n  }\n\n  .product-last-section-detail {\n    display: flex;\n    justify-content: end;\n    padding-top: 10px;\n    align-items: baseline;\n  }\n\n  .product-page\n    .ant-btn-variant-outlined:not(:disabled):not(.ant-btn-disabled):hover {\n    background-color: none;\n    border: none;\n    width: none !important;\n    height: 50px;\n    margin-top: 0rem !important;\n    color: rgb(12, 12, 12);\n  }\n\n  .ant-btn:not(:disabled):focus-visible {\n    outline: none !important;\n    outline-offset: 01px !important;\n    transition: none !important;\n  }\n\n  .price-section {\n    display: flex;\n    align-items: flex-end;\n  }\n\n  .navigation-icon {\n    width: 15px !important;\n  }\n\n  .miles-text {\n    color: #8e9190;\n    font-size: 15px;\n  }\n\n  .bookmark-icon {\n    margin-left: 8rem !important;\n    width: 17px !important;\n  }\n\n  .price-text {\n    color: black;\n    font-size: 17px;\n  }\n\n  .ant-pagination:not(.ant-pagination-disabled)\n    .ant-pagination-item:focus-visible {\n    outline: 1px solid #d2042d;\n    outline-offset: 1px;\n    transition:\n      outline-offset 0s,\n      outline 0s;\n  }\n\n  .ant-pagination .ant-pagination-item-active {\n    font-weight: 600;\n    background-color: #ffffff;\n    border-color: #fff;\n  }\n\n  .ant-pagination .ant-pagination-item-active a {\n    color: #d2042d;\n  }\n\n  .product-last-section-detail-map {\n    display: none;\n  }\n\n  .map-view-section {\n    display: none !important;\n  }\n}\n\n@media (max-width: 430px) {\n  .product-page-container {\n    height: 60px;\n  }\n  .products-list-container {\n    background: #f7f7f7;\n    padding: 5px;\n    height: 57vh !important;\n    overflow-y: scroll;\n  }\n  .toggle-filters {\n    color: #8e9190 !important;\n    font-size: 12px !important;\n  }\n  .find-your-text {\n    width: 100%;\n    padding-left: 0.6rem;\n    padding-top: 0.5rem;\n    font-size: 13px;\n  }\n\n  .product-page .ant-card .ant-card-body {\n    padding: 14px;\n    border-radius: 18 0 8px 8px;\n  }\n\n  .advertisement-txt {\n    color: #0a0f0d;\n    font-size: 17px;\n    font-weight: 700;\n  }\n\n  .mobile-view-filter-container {\n    padding: 0px 10px 0px 7px;\n  }\n\n  .filter-btn {\n    font-family: Roboto;\n    border: none !important;\n    height: 40px;\n    width: 86px;\n    font-size: 16px !important;\n    color: #000;\n    font-weight: 500;\n  }\n\n  .product-page\n    .ant-btn-variant-outlined:not(:disabled):not(.ant-btn-disabled):hover {\n    background-color: none;\n    border: none;\n    width: none !important;\n    height: 40px;\n    margin-top: 0rem !important;\n    color: rgb(12, 12, 12);\n  }\n\n  .search-input-sm {\n    font-family: Roboto;\n    height: 40px !important;\n    border: none;\n    border-radius: 8px;\n    font-size: 16px;\n  }\n\n  .current-loc-text {\n    font-family: Roboto;\n    color: #8e9190;\n    font-size: 13px;\n    font-weight: 400;\n  }\n\n  .location-text {\n    color: #000;\n    font-size: 13px;\n    font-weight: 500;\n  }\n\n  .map-location-icon {\n    width: 24px !important;\n    height: 24px !important;\n  }\n\n  .map-location-icon {\n    width: 24px !important;\n    height: 24px !important;\n  }\n\n  .toggle-filters {\n    color: #8e9190 !important;\n    font-size: 13px !important;\n  }\n\n  .loc-truncate {\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    max-width: 150px;\n    display: inline-block;\n  }\n\n  /** product listing card css*/\n\n  .product-image {\n    width: 120px !important;\n    height: 104px !important;\n  }\n\n  .product-id {\n    font-size: 13px !important;\n    color: #d2042d;\n    font-weight: 500;\n  }\n\n  .bookmark-icon {\n    margin-left: 41px !important;\n    width: 17px !important;\n  }\n\n  .available-txt {\n    font-size: 13px;\n    color: #8e9190;\n  }\n\n  .product-availability {\n    font-size: 13px;\n    font-weight: 600;\n  }\n\n  .middle-specification {\n    display: flex;\n    height: auto;\n    padding: 21px 0px 20px 0px !important;\n    justify-content: space-evenly;\n    flex-shrink: 0;\n  }\n\n  .product-size-img {\n    width: 20px;\n    height: 19px;\n  }\n\n  .product-size-text {\n    font-size: 13px;\n  }\n\n  .products-metric-icon {\n    width: 20px;\n    height: 20px;\n  }\n\n  .product-reach {\n    font-size: 13px;\n  }\n\n  .product-type {\n    font-size: 13px;\n  }\n\n  .navigation-icon {\n    width: 13px !important;\n  }\n\n  .miles-text {\n    color: #8e9190;\n    font-size: 13px;\n  }\n\n  .price-text {\n    color: black;\n    font-size: 19px;\n    font-weight: 700 !important;\n  }\n}\n\n@media (max-width: 375px) {\n  /** product listing card css*/\n\n  .product-image {\n    width: 110px !important;\n    height: 100px !important;\n    border-radius: 10px !important;\n  }\n  .advertisement-txt {\n    color: #0a0f0d;\n    font-size: 17px;\n    font-weight: 700;\n  }\n  .available-container {\n    padding-top: 15px !important;\n  }\n\n  .bookmark-icon {\n    margin-left: 18px !important;\n    width: 17px !important;\n  }\n\n  .middle-specification {\n    display: flex;\n    height: auto;\n    padding: 15px 0px 19px 0px !important;\n    justify-content: space-evenly;\n    flex-shrink: 0;\n  }\n\n  .toggle-filters {\n    color: #8e9190 !important;\n    font-size: 10px !important;\n  }\n}\n\n@media (max-width: 360px) {\n  .loc-truncate {\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    max-width: 120px;\n    display: inline-block;\n  }\n\n  .location-text {\n    color: #000;\n    font-size: 12px;\n    font-weight: 500;\n  }\n\n  .current-loc-text {\n    color: #8e9190;\n    font-size: 12px;\n    font-weight: 400;\n  }\n\n  .location-card .ant-card .ant-card-body {\n    padding: 5px !important;\n  }\n\n  .bookmark-icon {\n    margin-left: 8px !important;\n    width: 17px !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
